import GuessingMapButton from './GuessingMapButton';

export default GuessingMapButton;
